import Vue from 'vue';
import App from './App.vue';
import http from './api/http';
import router from './router/index';
import { scrollToLocation } from './common/utils';
import { reportLog } from './common/tool';
import { currentSsoUrl } from './common/ssoUrl';
import filters from './common/filters';
import store from './vuex/store';
import Vant, { Lazyload, Toast } from 'vant';
import './assets/scss/index.scss';
import 'vant/lib/index.css';

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;
Vue.use(Lazyload);
Vue.use(Vant);
Vue.prototype.$http = http;
Vue.prototype.$scroll = scrollToLocation;
Vue.prototype.$reportLog = reportLog;
Vue.prototype.$Toast = Toast;
Vue.prototype.$bus = new Vue();

let sso = new window.MiNiWan.MiniWanSso({
  url: currentSsoUrl,
  callback: (state, info) => {
    if (state == 1 || state == 2) {
      console.log('登录成功');
      window.sessionStorage.setItem('currentUser', JSON.stringify(info));
      window.sessionStorage.setItem('isLogin', true);
      store.dispatch('setUser', info);
    } else if (state == 0) {
      console.log('没有登入');
    } else if (state == 4) {
      console.log('sso内的接口调用失败');
    }
  }
});
Vue.prototype.$sso = sso;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
